import { render, staticRenderFns } from "./DocsToggleContent.vue?vue&type=template&id=26717407&scoped=true"
import script from "./DocsToggleContent.vue?vue&type=script&lang=js"
export * from "./DocsToggleContent.vue?vue&type=script&lang=js"
import style0 from "./DocsToggleContent.vue?vue&type=style&index=0&id=26717407&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26717407",
  null
  
)

export default component.exports